import { type PropsWithChildren } from "react";

import { useLocationPathname } from "./location";
import { RouteSwitchContext } from "./RouteSwitchContext";

export default function RouteSwitch(props: PropsWithChildren) {
    useLocationPathname();
    const slot: { owner: string | null } = { owner: null };
    const context = {
        register(id: string) {
            if (slot.owner === null) slot.owner = id;
            return slot.owner === id;
        },
    };
    return (
        <RouteSwitchContext.Provider value={context}>{props.children}</RouteSwitchContext.Provider>
    );
}
